import actions from './actions'
import { statuses } from '../../constants.json'
import { factoryReducer } from '../factory'

// Defining the Initial Variables to be saved in the Redux Store on initialize.
const initialState = {
  clinicPatientLoading: false,
  clinicPatientsList: [],
  lastTimezone: '',
  availableDevices: [],
  patientDetail: {},
  clinicPatientAddLoading: false,
  redirect: false,
  availableDevicesLoading: false,
  patientIds: [],
  redirectActivity: false,
  patientIdsLoading: false,
  clinicDeletedPatientsList: [],
  isUnassignModalVisible: false,
  patientLinkLoading: false,
  reportDataList: [],
  statusList: statuses,
  statusesLogs: [],
  groupedPatientsData: {},
}

export default factoryReducer(initialState, actions)
